import { errorWrapper } from 'utility/error';

import type { AggregatedActivityRequest } from './__GENERATED';
import { apiClient } from './api';
import { toAggregatedActivityDomain } from './transformers/toAggregatedActivityDomain';

// Fetches aggregated activities for a tenant and maps them onto the
// `Data.AggregatedActivity` domain. Resolution is locked to `Activity` — that
// matches how the dashboard groups rows (by activityId, with activityTypeId as
// the parent). `dates` is sent as null which the backend treats as "no date
// filter": the saga loads the full window during initialization and
// downstream selectors slice it by date.
async function getAggregatedActivities(args: {
  tenantId: string;
  resolution: AggregatedActivityRequest['resolution'];
}) {
  const { tenantId, resolution } = args;

  const apiCall = apiClient.ProducedActivity_GetAggregatedActivities(
    { resolution, dates: null },
    {
      params: { tenantId },
    },
  );

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to load aggregated activities',
    },
    onSuccess: (dtos) => {
      const { aggregatedActivityDomain } = toAggregatedActivityDomain({
        dtos: dtos ?? [],
      });
      return { aggregatedActivityDomain };
    },
  });
}

export { getAggregatedActivities };
